// extracted by mini-css-extract-plugin
export default {"homeSection":"Home_homeSection__99QQL"};